/**
 * @generated SignedSource<<0f81d2442537301c71c89497895178b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MusicParseStatus = "ERROR" | "IN_PROGRESS" | "NOT_STARTED" | "SKIPPED" | "SUCCESS" | "%future added value";
export type MusicParseStepNoteFinderUserConfirmationInput = {
  page_id: string;
  parse_step_id: string;
};
export type NoteFinderUserConfirmationMutation$variables = {
  input: MusicParseStepNoteFinderUserConfirmationInput;
};
export type NoteFinderUserConfirmationMutation$data = {
  readonly music_parse_step_note_finder_user_confirmation: {
    readonly parse_step: {
      readonly id: string;
      readonly status: MusicParseStatus;
    };
  } | null;
};
export type NoteFinderUserConfirmationMutation = {
  variables: NoteFinderUserConfirmationMutation$variables;
  response: NoteFinderUserConfirmationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MusicParseStepOutput",
    "kind": "LinkedField",
    "name": "music_parse_step_note_finder_user_confirmation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicParseStep",
        "kind": "LinkedField",
        "name": "parse_step",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NoteFinderUserConfirmationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NoteFinderUserConfirmationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b8f4f78c071a050f5b1a8d1361592f74",
    "id": null,
    "metadata": {},
    "name": "NoteFinderUserConfirmationMutation",
    "operationKind": "mutation",
    "text": "mutation NoteFinderUserConfirmationMutation(\n  $input: MusicParseStepNoteFinderUserConfirmationInput!\n) {\n  music_parse_step_note_finder_user_confirmation(input: $input) {\n    parse_step {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e75f4adb8a60658b1f92806e3160cbf9";

export default node;
